import * as svg from "../../../assets/vrbo-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const VRBOIcon = iconBuilder(svg, "VRBOIcon", "0 0 80.6 74.4");
